import { createContext, RefObject } from 'react'

export interface FocusContextType {
  inputs: Record<string, RefObject<HTMLElement>>
  registerInput?: (name: string, ref: RefObject<HTMLElement>) => void
  setFocusInput: (name: string) => void
}

export const FocusContext = createContext<FocusContextType>({
  inputs: {},
  setFocusInput: () => null,
})
